import React from 'react';
import {
    arrayOf,
    bool,
    func,
    string,
    shape,
    exact,
    oneOfType,
    object,
} from 'prop-types';
import MUITableHead from '@material-ui/core/TableHead';

import {ColumnType, Sort} from '../tableTypes';
import TableHeaderContainer from './TableHeaderContainer';

interface TableHeaderProps {
    columns: ColumnType[],
    setSort?: (sort: Sort) => void,
    sort?: Sort,
}

export default function TableHeader({columns, setSort, sort}: TableHeaderProps) {
    return (
        <MUITableHead>
            <TableHeaderContainer
                columns={columns}
                setSort={setSort}
                sort={sort}
            />
        </MUITableHead>
    );
}

TableHeader.propTypes = {
    columns: arrayOf(shape({
        dataKey: string,
        title: oneOfType([
            string,
            object,
        ]),
        render: func,
        sortable: bool,
    })).isRequired,
    setSort: func,
    sort: exact({
        sortBy: string,
        sortOrder: string,
    }),
};

TableHeader.defaultProps = {
    sort: undefined,
    setSort: undefined,
};
